import * as React from "react";

const SvgIcnHold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="currentColor" fillRule="nonzero">
            <path d="M8 5h2a1 1 0 011 1v12a1 1 0 01-1 1H8a1 1 0 01-1-1V6a1 1 0 011-1zm0 1v12h2V6H8zM14 5h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V6a1 1 0 011-1zm0 1v12h2V6h-2z" />
        </g>
    </svg>
);

export default SvgIcnHold;
